import { useNavigate } from 'react-router-dom';

import { ArrowLeftIcon } from './icons.js';
import { useI18n } from '../i18n/index.js';
import styles from '../routes/pageStyles.module.css';

/**
 * 내 프로필로 돌아가는 화살표.
 *
 * 설정·인연·나를 본 사람은 **프로필에서 갈라져 나온 화면**이다. 헤더의 내
 * 사진은 이 화면들에서도 프로필로 데려다주지만, 그건 "어디서나 내 계정으로"
 * 라는 뜻이지 "방금 있던 곳으로 돌아간다"는 뜻이 아니다. 갈라져 나온 길에는
 * 돌아가는 길이 눈에 보여야 한다.
 *
 * `navigate(-1)`이 아니라 **갈라져 나온 자리로 보낸다.** 주소를 직접 치고
 * 들어왔거나 새로고침한 뒤에는 뒤로 갈 곳이 이 앱 밖일 수 있다.
 *
 * 남의 인연 목록에서는 돌아갈 곳이 내 프로필이 아니라 **보고 있던 사람**이라
 * `to`로 받는다. 안 주면 내 프로필이다.
 */
export function BackLink({ to = '/me' }: { to?: string }) {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={styles.backLink}
      aria-label={t('nav.backToProfile')}
      title={t('nav.backToProfile')}
      onClick={() => navigate(to)}
    >
      <ArrowLeftIcon size={20} />
    </button>
  );
}
